/**
 * Zustand store for scio1 modal adapter state.
 *
 * Manages the bridge function (provided by Scio1Frame mode="modal") and modal visibility.
 * Consumed by useSubscriptionModal hook to open payment modals in the scio1 iframe.
 */
import { create } from 'zustand';

type SendWithPromiseFn = <T = unknown>(
  event: string,
  data: unknown,
  timeoutMs?: number,
) => Promise<T>;

type PostToIframeFn = (data: Record<string, unknown>) => void;

interface Scio1ModalState {
  /** Whether the modal adapter iframe is visible (overlay mode) */
  modalVisible: boolean;
  /** The bridge function provided by Scio1Frame mode="modal" when ready */
  sendWithPromise: SendWithPromiseFn | null;
  /** Fire-and-forget postMessage to the scio1 iframe */
  postToIframe: PostToIframeFn | null;

  registerBridge: (fn: SendWithPromiseFn, postFn: PostToIframeFn) => void;
  unregisterBridge: () => void;
  showModal: () => void;
  hideModal: () => void;
}

export const useScio1ModalStore = create<Scio1ModalState>((set) => ({
  modalVisible: false,
  sendWithPromise: null,
  postToIframe: null,

  registerBridge: (fn, postFn) => set({ sendWithPromise: fn, postToIframe: postFn }),
  unregisterBridge: () => set({ sendWithPromise: null, postToIframe: null }),
  showModal: () => set({ modalVisible: true }),
  hideModal: () => set({ modalVisible: false }),
}));
